import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Parser from 'html-react-parser';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';

import { getIntegrationsURLPath } from '../../helpers/Integrations';

import IntegrationsButton from './Button';
import UpgradePlanButton from '../UpgradePlanButton';

const IntegrationsListItem = ({
  integration,
  disconnectingServiceId,
  handleDisconnect,
}) => {
  const intl = useIntl();

  const linkTo = {
    pathname: `${getIntegrationsURLPath()}/${integration.id}`,
    state: {
      goBackToListButton: {
        text: intl.formatMessage({ defaultMessage: 'Back to all Integrations' }),
        pathname: getIntegrationsURLPath(),
      },
    },
  };

  return (
    <div className="integrations-list-element">
      <div className="integration-header">
        <div className="integration-logo">
          <img
            id={`integration-logo-${integration.id}`}
            src={integration.logo_url}
            alt={integration.name}
          />
        </div>
        {integration.feature && (
          <UpgradePlanButton
            feature={integration.feature.slug}
          />
        )}
      </div>
      <div className="integration-name">
        <div className="integration-name-container">
          {(integration.website_url || integration.type === 'importer') ? (
            integration.name
          ) : (
            <Link to={linkTo}>
              {integration.name}
            </Link>
          )}
        </div>
      </div>
      <div className="integration-description">
        {Parser(integration.description)}
      </div>
      <div className="integration-actions">
        <IntegrationsButton
          integration={integration}
          disconnecting={disconnectingServiceId === integration.id}
          handleDisconnect={handleDisconnect}
        />
        {(integration.is_connected && integration.supports.includes('notifications')) && (
        <Button tag={Link} to="/profile/edit?tab=notifications" color="link">
          {intl.formatMessage({ defaultMessage: 'Notification settings' })}
        </Button>
        )}
      </div>
    </div>
  );
};

IntegrationsListItem.propTypes = {
  integration: PropTypes.object.isRequired,
  disconnectingServiceId: PropTypes.string,
  handleDisconnect: PropTypes.func.isRequired,
};

IntegrationsListItem.defaultProps = {
  disconnectingServiceId: null,
};

export default IntegrationsListItem;
